import React from "react";
import "../styles/legal.css";

const Impressum = () => {
  return (
    <section className="privacy-section py-2" id="impressum">
      <div className="container">
        <div className="text-center mb-4 pt-1">
          <h2 className="fw-bold pt-5">Impresszum</h2>
          <div className="privacy-divider mx-auto my-3"></div>
          <p className="mb-4 text-muted">
            Az alábbiakban a szolgáltató jogi adatait és kötelező tájékoztatását
            találja.
          </p>
        </div>

        <div className="privacy-content">
          <h4>1. Szolgáltató adatai</h4>
          <p>
            <strong>Név:</strong> Dr. Dósa Nikolett
            <br />
            <strong>Székhely:</strong> {/* add meg */}
            <br />
            <strong>Telefonszám:</strong> {/* add meg */}
            <br />
            <strong>E-mail cím:</strong> <a href="mailto:info@domain.hu"></a>
          </p>

          <h4>2. Tárhelyszolgáltató</h4>
          <p>
            <strong>Szolgáltató:</strong> Amazon Web Services (AWS)
            <br />
            <strong>Székhely:</strong> Seattle, WA, USA
          </p>

          <h4>3. Felelősség kizárása</h4>
          <p>
            A weboldalon található információk tájékoztató jellegűek. A
            szolgáltató nem vállal felelősséget a tartalom pontosságáért.
          </p>

          <h4>4. Szerzői jog</h4>
          <p>
            A weboldalon található tartalmak szerzői jogi védelem alatt állnak.
            Felhasználásuk kizárólag írásos engedéllyel lehetséges.
          </p>

          <h4>5. Jogviták</h4>
          <p>
            A weboldal használatából eredő jogviták esetén a magyar jog az
            irányadó.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Impressum;
